import React from 'react'
import PropTypes from 'prop-types'

const ScoringPreview = ({ survey, clinro, diary, isSurvey, isClinro, isDiary }) => {
  const instrument = isClinro ? clinro : isDiary ? diary : survey
  const scores = instrument?.scores || []
  const domains = instrument?.domains || {}

  if (!scores || scores.length === 0) {
    return null
  }

  const escapeRegExp = str => String(str).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

  // Prefer tagFormula when available since it carries domain labels already.
  // Fallback to replacing domain IDs in `formula` with domain labels from `instrument.domains`.
  const formatScoreFormula = score => {
    if (!score) return '---'

    const { tagFormula, formula } = score

    if (typeof tagFormula === 'string' && tagFormula.length > 0) {
      // tagFormula example:
      // [[{"id":"s9aa3da","value":"Domain Label"}]]+[[{"id":"m9a0562","value":"Other Label"}]]
      return tagFormula.replace(/\[\[\{.*?\}\]\]/g, match => {
        const inner = match.slice(2, -2) // remove leading [[ and trailing ]]
        try {
          const parsed = JSON.parse(inner)
          const val = parsed?.value ?? domains?.[parsed?.id]?.label
          return val != null && val !== '' ? String(val) : parsed?.id || match
        } catch (e) {
          // If multiple objects are present, try parsing as an array.
          try {
            const arr = JSON.parse(`[${inner}]`)
            if (Array.isArray(arr)) {
              const parts = arr
                .map(o => o?.value ?? domains?.[o?.id]?.label ?? o?.id)
                .filter(Boolean)
                .map(String)
              return parts.length ? parts.join(', ') : match
            }
          } catch (e2) {
            // Fall through
          }
          return match
        }
      })
    }

    if (typeof formula !== 'string' || formula.length === 0) return '---'

    // Replace all domain IDs with their labels (word-boundary match to avoid partial replacements).
    const domainIds = Object.keys(domains)
      .filter(Boolean)
      .sort((a, b) => String(b).length - String(a).length)

    return domainIds.reduce((acc, id) => {
      const label = domains?.[id]?.label
      if (!label) return acc
      return acc.replace(new RegExp(`\\b${escapeRegExp(id)}\\b`, 'g'), String(label))
    }, formula)
  }

  return (
    <div className='scoring-preview'>
      <table>
        <tbody>
          {scores.map((score, index) => (
            <tr key={`score-${index}`}>
              <td className='first-column'>Score Number {index + 1}</td>
              <td>{formatScoreFormula(score)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

ScoringPreview.propTypes = {
  survey: PropTypes.object,
  clinro: PropTypes.object,
  diary: PropTypes.object,
  isSurvey: PropTypes.bool,
  isClinro: PropTypes.bool,
  isDiary: PropTypes.bool,
}

export default ScoringPreview
